import { Injectable, Inject } from '@angular/core';
import { IndustriepartnerService } from './interfaces/industriepartner.service';
import {
    IndustriepartnerDefaultDTO,
    KundenlisteParseMismatchEntry,
    FehlerKorrekturDTO,
    UserRoles,
} from '../../shared/model';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SERVICE_URL } from '../../../environments/tokens';
import { HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable()
export class IndustriepartnerHttpService implements IndustriepartnerService {
    private serviceUrl: string;
    private fehlerListe: KundenlisteParseMismatchEntry[] = [];

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8',
        }),
    };

    constructor(
        private http: HttpClient,
        private auth: AuthService,
        @Inject(SERVICE_URL) public baseUrl: string
    ) {
        this.serviceUrl = baseUrl + 'industriepartner';
    }

    getIndustriepartnerDefaults(): Observable<IndustriepartnerDefaultDTO> {
        return this.http.get<IndustriepartnerDefaultDTO>(
            `${this.serviceUrl}/defaults/${this.getAnbieterNr()}`
        );
    }

    setIndustriepartnerDefaults(
        mindestBestellMenge: number,
        mindestUmsatz: number,
        skonto: number,
        zusatzrabatt: number,
        lieferzeit: number,
        mengeObergrenze: number,
        lieferwegUeberweiser: boolean,
        lieferwegDirekt: boolean,
        bestell_email_empfaenger: string,
        bestell_email_zeit: string,
        mindestbestellmenge_versandeinheiten: boolean,
        mengenrabatte: any[],
        triggerbilder: any[],
    ): Observable<IndustriepartnerDefaultDTO> {
        const defaults: IndustriepartnerDefaultDTO = {
            mindestBestellMengeDefault: mindestBestellMenge,
            mindestUmsatzDefault: mindestUmsatz,
            skonto,
            zusatzrabatt,
            lieferzeit,
            mengeObergrenze,
            lieferwegUeberweiser,
            lieferwegDirekt,
            bestell_email_empfaenger,
            bestell_email_zeit,
            mindestbestellmenge_versandeinheiten,
            mengenrabatte,
            triggerbilder,
        };
        console.log(defaults);
        return this.http.post<IndustriepartnerDefaultDTO>(
            `${this.serviceUrl}/defaults/${this.getAnbieterNr()}`,
            defaults
        );
    }
    setAnbieterNr(anbieterNr: number) {
        if (anbieterNr === null) {
            sessionStorage.removeItem('anbieterNummer');
        } else {
            sessionStorage.setItem('anbieterNummer', anbieterNr.toString());
        }
    }

    getAnbieterNr(): number {
        var anbieterNr = sessionStorage.getItem('anbieterNummer');
        return anbieterNr == null
            ? this.auth.currentUserValue.anbieterNummer
            : +anbieterNr;
    }

    kundenListeEinlesen(
        file: File
    ): Observable<KundenlisteParseMismatchEntry[]> {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post<KundenlisteParseMismatchEntry[]>(
            `${this.serviceUrl}/kundenliste/${this.getAnbieterNr()}`,
            formData
        );
    }

    fehlerAbrufen(): Observable<KundenlisteParseMismatchEntry[]> {
        return this.http.get<KundenlisteParseMismatchEntry[]>(
            `${this.serviceUrl}/kundenliste/errors/${this.getAnbieterNr()}`,
            this.httpOptions
        );
    }
    setFehlerListe(fehlerListe: KundenlisteParseMismatchEntry[]): void {
        this.fehlerListe = fehlerListe;
    }
    getFehlerListe(): Observable<KundenlisteParseMismatchEntry[]> {
        return of(this.fehlerListe);
    }
    fehlerKorrigieren(korrekturen: FehlerKorrekturDTO[]): Observable<void> {
        return this.http.post<void>(
            `${this.serviceUrl}/kundenliste/corrected/${this.getAnbieterNr()}`,
            korrekturen
        );
    }

    getAllIndustriepartner() {
      return this.http.get(`${this.serviceUrl}/all`);
    }

    getIndustriepartner(anbieterNr) {
      return this.http.get(this.baseUrl+'stammdaten/industriepartner/'+anbieterNr);
    }

    getIndustriepartnerDetails(anbieterNr) {
        return this.http.get(this.baseUrl+'industriepartner/'+anbieterNr);
    }

    deactivateIndustriepartner(kundenkennung) {
      return this.http.post(this.baseUrl+'stammdaten/industriepartner/deactivate', {kundenkennung: kundenkennung});
    }

    activateIndustriepartner(kundenkennung) {
      return this.http.post(this.baseUrl+'stammdaten/industriepartner/activate', {kundenkennung: kundenkennung});
    }

    addIndustriepartnerSub(subData) {
      return this.http.post(this.baseUrl+'stammdaten/industriepartner/subs/add', subData);
    }

    updateApothekenIndustriepartnerDaten(data) {
        return this.http.post(this.serviceUrl+'/apothekendaten/update', data);
    }
    updateApothekenIndustriepartnerStatus(data) {
      return this.http.post(this.serviceUrl+'/apothekendaten/status', data);
    }
    getIndustriepartnerSmallList() {
        return this.http.get(this.baseUrl + 'admin/industriepartner/list');
    }
    addIndustriepartner(anbieterNr) {
        return this.http.post(this.baseUrl + 'admin/industriepartner/neu', {anbieterNr: anbieterNr});
    }
    addIndustriepartnerAuth(indForm) {
        return this.http.post(this.baseUrl + 'admin/industriepartner/auth', indForm);
    }

    uploadArtikelstamm(anbieterNr, file) {
        const formData = new FormData();
        formData.append('anbieterNr', anbieterNr);
        formData.append('file', file);
        return this.http.post(this.baseUrl + 'industriepartner/artikelstamm/einlesen', formData);
    }

    uploadCustomerRow(industriepartner, row) {
      return this.http.post(this.baseUrl + 'industriepartner/' + industriepartner+'/upload/kundenzeile', {row: row});
    }

    loadBestandsApiToken(industriepartner) {
      let url = this.baseUrl + 'bestandsmeldung/api-token';
      return this.http.post(url, {anbieterNummer: industriepartner});
    }

    changeApiState(industriepartner) {
      let url = this.baseUrl + 'bestandsmeldung/api-state';
      return this.http.post(url, {anbieterNummer: industriepartner});
    }

    useEmailAssistent(data) {
      let url = this.baseUrl + 'industriepartner/email-assistent';
      return this.http.post(url, data);
    }

    retrieveEmailAssistentState(data) {
      let url = this.baseUrl + 'industriepartner/email-assistent-state';
      return this.http.post(url, data);
    }
}
